import { Store, select } from '@ngrx/store';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { AppState, selectLocation, selectUserApplicationProfiles, selectUserProfile } from '@app/core/ngrx';
import { NavigationService } from '@app/core/services/navigation.service';
import { BrowserGlobalRef } from '@app/shared/global-ref';
import { AppMenuItems, AppMenuItems2, AppMenuItems3, UserMenuItems } from '@app/shared/data/navigation.data';
import { MenuItem } from '@app/core/models';
import { Subscription } from 'rxjs/internal/Subscription';
import { Observable } from 'rxjs/internal/Observable';
import { Router } from '@angular/router';
import { environment } from '@env/environment';
import { ChatService } from '@app/core/services';
import * as txml from 'txml';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { SharedModule } from '@app/shared/shared.module';

@Component({
  selector: 'ecp-portal',
  templateUrl: './portal.component.html',
  styleUrls: ['./portal.component.scss'],
  standalone: true,
  imports: [SharedModule],
})
export class PortalComponent implements OnInit, OnDestroy {
  // @select(['user', 'profile', 'applicationProfiles'])
  public applicationProfiles$: Observable<any[]>;
  /**
   * subscription$
   */
  private subscription$ = new Subject<void>();
  /**
   * menu
   */
  public menu: any = {
    app: [],
    user: [],
  };
  /**
   * appNav
   */
  public appNav: MenuItem[] = AppMenuItems;
  public appNoKpiNav: MenuItem[] = AppMenuItems2;
  public appAdminNav: MenuItem[] = AppMenuItems3;
  /**
   * userNav
   */
  public userNav: MenuItem[] = UserMenuItems;
  private _myLinkLocations = ['MED-289', 'MED-290', 'MED-291', 'MED-292', 'MED-293', 'MED-294', 'MED-352', 'MED-663'];
  // chatStatus = 'Offline';
  currentLocation: any;
  isMinimized = false;
  showDesktopLoginMessage = false;
  readonly desktopLoginMessage = 'Please use the MyLink desktop version to sign in.';
  constructor(
    private store: Store<AppState>,
    private navigationService: NavigationService,
    private _global: BrowserGlobalRef,
    private _router: Router,
    private chatService: ChatService,
  ) {
    this.applicationProfiles$ = this.store.pipe(select(selectUserApplicationProfiles));
    this.store.pipe(select(selectUserProfile), takeUntil(this.subscription$)).subscribe(() => {
      this.setupNavigationItems();
    });

    this.store.pipe(select(selectLocation), takeUntil(this.subscription$)).subscribe((location) => {
      if (location && location.location) {
        this.currentLocation = location.location.location;
      }
    });
  }

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  ngOnInit() {
    // this.chatService.getAgentAvailability().subscribe((data: any) => {
    //   // console.log('data.available => ', data.available);
    //   if (data.available === 'true' || data.available === 'TRUE' || data.available) {
    //     this.chatStatus = 'Online';
    //   }
    // });
  }

  setupNavigationItems(): void {
    this.applicationProfiles$.subscribe((profiles) => {
      // loop through the applications for the MYLINK app
      if (profiles) {
        profiles.forEach((app) => {
          if (app.application.toLowerCase().includes('med mylink')) {
            // MED Locations the user has access to:
            if (this.findCommonElements3(this._myLinkLocations, app.medLocations)) {
              // set the default navigation
              this.menu = {
                app: this.appNav,
                user: this.userNav,
              };
            } else if (app.medRole === 'EssilorAdmin') {
              this.menu = {
                app: this.appAdminNav,
                user: this.userNav,
              };
            } else {
              // hide the kpi link
              this.menu = {
                app: this.appNoKpiNav,
                user: this.userNav,
              };
            }
          }
        });
      }
    });
  }

  openLoginDialog(event: Event): void {
    event?.preventDefault();
    this.showDesktopLoginMessage = true;
  }

  // goToChat() {
  //   window.open(environment.eceChatURL, '_blank');
  // }

  ngOnDestroy(): void {
    this.subscription$.next();
    this.subscription$.complete();
  }

  private findCommonElements3(arr1, arr2) {
    return arr1.some((item) => arr2.includes(item));
  }
}
